module.exports = __webpack_public_path__ + "static/media/Dante Symphony.58a37bca.png";